import markDark from "../../../../assets/logo/mark-dark.png";

interface MarkProps {
  size?: number;
  title?: string;
  className?: string;
}

export function Mark({ size = 24, title = "StageGrid Systems", className }: MarkProps) {
  return (
    <img
      className={className ? `sgs-mark ${className}` : "sgs-mark"}
      src={markDark}
      width={size}
      height={size}
      alt={title}
      style={{ display: "block", width: size, height: size }}
    />
  );
}

interface LockupProps {
  size?: number;
  orientation?: "horizontal" | "stacked";
  className?: string;
}

export function Lockup({ size = 22, orientation = "horizontal", className }: LockupProps) {
  if (orientation === "stacked") {
    return (
      <span
        className={className}
        style={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 8,
          color: "currentColor",
        }}
      >
        <Mark size={size * 1.8} />
        <Wordmark size={size * 0.9} />
      </span>
    );
  }
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        color: "currentColor",
      }}
    >
      <Mark size={size + 4} />
      <Wordmark size={size} />
    </span>
  );
}

interface WordmarkProps {
  size?: number;
}

function Wordmark({ size = 22 }: WordmarkProps) {
  return (
    <span
      style={{
        fontFamily: "var(--sgs-font-sans)",
        fontSize: size,
        letterSpacing: "-0.01em",
        color: "currentColor",
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ fontWeight: 700 }}>StageGrid</span>
      <span style={{ fontWeight: 400, marginLeft: 6 }}>Systems</span>
    </span>
  );
}
